import React from 'react'

export default function Footer({GoUp}) {
    return (
        <div>
            <footer class="footer">
                <div class="footer-content">
                    <p class="copyright">
                        Copyright &copy; 2020, ToFro Logistics - All Rights Reserved
                    </p>
                    <div class="social-list">
                        <a href="/"><i class="fab fa-facebook-f"></i></a>
                        <a href="/"><i class="fab fa-instagram"></i></a>
                        <a href="/"><i class="fab fa-twitter"></i></a>
                    </div>
                </div>
            </footer>
            <div onClick={GoUp} class="scroll-btn">
                <i class="fas fa-arrow-up"></i>
            </div>
            <a href="https://wa.me/+2348066994918">
                <div class="scroll-btn2">
                    <i class="fab fa-whatsapp"></i>
                </div>
            </a>
        </div>
    )
}
